import React from 'react';
import { IconButton, Menu, MenuItem, Box, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

interface FlagOption {
  lang: string;
  name: string;
  flag: string;
}

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const languageOptions: FlagOption[] = [
    {
      lang: 'en',
      name: 'English',
      flag: '/images/flags/en.svg'
    },
    {
      lang: 'es',
      name: 'Español',
      flag: '/images/flags/es.svg'
    },
    {
      lang: 'de',
      name: 'Deutsch',
      flag: '/images/flags/de.svg'
    }
  ];

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng: string) => {
    const path = location.pathname;
    const pathWithoutLang = path.replace(/^\/(en|es|de)(\/|$)/, '/');
    const newPath = `/${lng}${pathWithoutLang === '/' ? '' : pathWithoutLang}`;
    navigate(newPath);
    handleClose();
  };

  const currentLanguage = languageOptions.find(option => option.lang === i18n.language) || languageOptions[0];

  return (
    <>
      <Tooltip title="Change language">
        <IconButton 
          color="inherit" 
          onClick={handleClick}
          sx={{ 
            padding: { xs: 0.5, sm: 1 },
            ml: { xs: 0, sm: 1 },
            borderRadius: 1,
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            }
          }}
          aria-label="Select language"
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <img 
              src={currentLanguage.flag} 
              alt={currentLanguage.name} 
              width="24" 
              height="24" 
            />
          </Box>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {languageOptions.map((option) => (
          <MenuItem 
            key={option.lang} 
            onClick={() => changeLanguage(option.lang)}
            selected={i18n.language === option.lang}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img 
                src={option.flag} 
                alt={option.name} 
                width="24" 
                height="24" 
                style={{ marginRight: 8 }}
              />
              {option.name}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
